define([
    "./tdnHelpModule",
    "./nlgTdnHelp",
    "./tdnHelpProvider",
    "./tdnHelpTitle/nlgTdnHelpTitle"
], function () {
});